import { Card, FormLayout, Layout, ResourceItem, ResourceList, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import ResourceListHelper from "../../helpers/ResourceListHelper";
import { CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import Switch from "react-switch/index";
import HeadingHelper from "../../helpers/HeadingHelper";
import React from "react";

const SRShipping = props => {
  const {
    validatorClass,
    freeShipping, describeTheConditions,
    shippingTable,
    cutOffTimes,
    handleChange,
    handleArrayChange, handleArrayAdded, handleArrayRemoved,
  } = props;

  const renderShippingTableItem = (item, id, index) => {
    const name = 'shippingTable';
    const doValidation = !!(item.area || item.method || item.carrier || item.cost_conditions);  // Return string
    const validationRule = !doValidation ? '' : <V.Item rule="required" title={CsI18n.t('This field is required.')} />;
    return (
      <Card sectioned title={`${CsI18n.t('Method')}: ${index + 1}`}
            actions={ResourceListHelper.itemAction(name, index, handleArrayRemoved)}>
        <ResourceItem id={index}>
          <FormLayout>
            <FormLayout.Group>
              <V dynamicRules={true}>
                <TextField label={CsI18n.t('Area')} value={item.area}
                           placeholder={CsI18n.t('shipping_table.placeholder.area')}
                           onChange={handleArrayChange(name, index, 'area')} />
                {validationRule}
              </V>
              <V dynamicRules={true}>
                <TextField label={CsI18n.t('Method')} value={item.method}
                           placeholder={CsI18n.t('shipping_table.placeholder.method')}
                           onChange={handleArrayChange(name, index, 'method')} />
                {validationRule}
              </V>
              <V dynamicRules={true}>
                <TextField label={CsI18n.t('Carrier')} value={item.carrier}
                           placeholder={CsI18n.t('shipping_table.placeholder.carrier')}
                           onChange={handleArrayChange(name, index, 'carrier')} />
                {validationRule}
              </V>
            </FormLayout.Group>
            <FormLayout.Group>
              <V dynamicRules={true}>
                <TextField label={CsI18n.t('Cost/conditions')} value={item.cost_conditions}
                           placeholder={CsI18n.t('shipping_table.placeholder.cost_conditions')}
                           onChange={handleArrayChange(name, index, 'cost_conditions')} />
                {validationRule}
              </V>
            </FormLayout.Group>
          </FormLayout>
        </ResourceItem>
      </Card>
    );
  }

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("shipping.annotate.title.shipping")}
      description={CsI18n.t('shipping.annotate.desc.shipping')}>
      <Layout.Section>
        <Card sectioned>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <div>
                {HeadingHelper.h3tt('Free shipping', 'shipping.explain.free_ship')}
                <Switch
                  className="react-switch"
                  onChange={handleChange('freeShipping')}
                  checked={freeShipping}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  aria-label={CsI18n.t("Free shipping")}
                />
              </div>
              <TextField
                label={HeadingHelper.h3tt('Describe the conditions', 'shipping.explain.conditions')}
                onChange={handleChange("describeTheConditions")}
                value={describeTheConditions}
                placeholder={CsI18n.t('shipping.placeholder.conditions')}
                // Eg: We offer FREE shipping on all orders of $75 or more for all domestic orders. For orders under $75 we offer Standard Ground shipping for a flat fee of $9.95 Free returns are provided on all domestic orders. For international orders see our rates listed below.
                multiline
              />

              {HeadingHelper.h3tt('Shipping table', 'shipping.explain.shipping_table')}
              <ResourceList
                items={shippingTable}
                renderItem={renderShippingTableItem}
                alternateTool={ResourceListHelper.addNewAction('shippingTable', handleArrayAdded)}
              />

              <TextField
                label={HeadingHelper.h3tt('Cut off times', 'shipping.explain.cut_off_times')}
                onChange={handleChange("cutOffTimes")}
                value={cutOffTimes}
                placeholder={CsI18n.t('shipping.placeholder.cut_off_times')}
                // `Eg: GROUND SHIPPING: Orders received by 12pm GMT+1 are shipped out the same business day via our free ground shipping option. Orders received after 12pm EST are shipped the following business day.
                // EXPRESS ORDERS: Overnight Express and 2-Day Shipping orders are shipped out the same day if received by 2pm GMT+1 Orders received after 2pm will ship out the following business day.`
                multiline
              />
            </FormLayout>
          </CsValidationForm>
        </Card>
      </Layout.Section>
    </Layout.AnnotatedSection>
  )
};

export default SRShipping;